/**
 * モバイル用の「電話番号」の形式を確認する
 * ハイフン除去後の 11 桁/14 桁入力を許容し、画面入力の揺れを吸収する。
 * @param value 検証値
 * @returns 正しい場合は、trueを返却する。それ以外は、falseを返却する
 */
export const isMobilePhoneNumberFormat = (value: string | undefined): boolean => {
  if (!value) {
    return false;
  }
  //   11桁用、14桁用の形式パターンを定義する
  const pattern11 = /^[0]{1}[0-9]{10}$/;
  const pattern14 = /^[0]{1}[0-9]{13}$/;
  if (pattern11.test(value)) {
    return true;
  }
  if (pattern14.test(value)) {
    return true;
  }
  return false;
};

/**
 * 「固定電話番号」の「番号ポータビリティ」の入力値の確認処理を実施する
 * 携帯・IP電話・フリーダイヤルを除外し、移転可能な0ABJ番号だけを通す。
 * @param value 固定電話番号
 * @returns 正しい場合は、trueを返却する。それ以外は、falseを返却する
 */
export const isLocalNumberPortabilityPhoneNumber = (value: string | undefined): boolean => {
  if (!value) {
    return false;
  }
  // 「0ABJ番号」の形式の確認を実施する
  const format = /^[0]{1}[0-9]{9}$/;
  if (!format.test(value)) {
    return false;
  }

  // 先頭が特定番号かどうかの確認を実施する
  const prefixPatterns = ['090', '080', '070', '060', '050', '0120', '0800', '0570'];
  const index = prefixPatterns.findIndex((e) => {
    return value.startsWith(e);
  });
  if (index >= 0) {
    return false;
  }

  return true;
};

export default isMobilePhoneNumberFormat;
